/* eslint-disable max-len */
import React, { Fragment } from 'react'
import Pagination from '../../../../components/Pagination';
import { formatAdjustedDate } from '../../../../CommonMethods/formatDate';

const Table = ({PayablesList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    reportTotal,
    startDate,
    endDate,
    PayablesCount}) => {
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (

        <div class="-mx-1">
            <div className='text-center absolute w-full'>Entry Date from <span className="font-semibold">{searchParams?.get('start_date') === null ? formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ? formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
            <div class="flex mb-1 overflow-auto pb-[6px] scroll-bar px-1 topHeading" id='search-result'>
                <table aria-label="Outside Table" class="w-full " id="admin-table">
                    <thead>
                        <tr>
                            <th class="w-[12%]">
                                <span class="flex items-center justify-start">Entry Date
                                </span>
                            </th>
                            <th class="w-[14%]">
                                <span class="flex items-center justify-start">GRN #/JNV #
                                </span>
                            </th>
                            <th class="w-[40%]">
                                <span class="flex items-center justify-start">Vendor Name/Account
                                </span>
                            </th>
                            <th class="w-[15%]">
                                <span class="flex items-center justify-start">Reference #
                                </span>
                            </th>
                            <th class="w-[17%]">
                                <span class="flex items-center justify-end text-right">Pending Amount
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>
                    </thead>
                    <tbody >
                        {PayablesList?.map((payable) => (
                            <>
                                <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                <tr class="">
                                    <td class="text-start">{formatAdjustedDate(payable?.date) || '-'}</td>
                                    <td class="text-start">{payable?.grn_jnv_number || '-'}</td>

                                    <td class="text-start">{payable?.account_name || '-'}</td>
                                    <td class="text-start capitalize">{payable?.reference_number || '-'}</td>
                                    <td class="text-end ">{parseFloat(payable?.pending_amount).toFixed(2) || '-'}</td>

                                </tr>
                            </>))}
                        {PayablesCount !== 0 && (<>
                            <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                            <tr class="">
                                <td class="font-semibold text-start" colSpan={4}>
                                    <p>Payable Total</p>
                                </td>
                                <td class="font-semibold text-end">
                                    <p>{parseFloat(reportTotal).toFixed(2) || '-'}</p>
                                </td>
                            </tr></>)}
                    </tbody>
                    {PayablesCount === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="5" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Payables found.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            {PayablesCount > 10 && <Pagination
                TotalCount={PayablesCount}
                totalPageNumber={Math?.ceil(PayablesCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>

    )
}
export default Table;   